export enum Paths {
  HOME = '',
  FAVORITES = 'favorites',
  PROFILE = 'profile',
  GEMS = 'gems',
  USER = 'user',
  COMMENT = 'comment',
  MESSAGE = 'message'
}
